import { DiccionarioIdiomas } from '@nucleo/i18n/traduccion-util';

/** Textos comunes de las pantallas dirigidas por descriptor (listado, formulario, ficha, consultas). */
const TEXTOS_CRUD_ES = {
  inicio: 'Inicio',
  buscar: 'Buscar',
  todos: 'Todos',
  nuevo: 'Nuevo',
  editar: 'Editar',
  eliminar: 'Eliminar',
  verFicha: 'Ver ficha',
  historial: 'Historial',
  guardar: 'Guardar',
  cancelar: 'Cancelar',
  cerrar: 'Cerrar',
  confirmar: 'Confirmar',
  agregar: 'Agregar',
  consultar: 'Consultar',
  vacio: 'No hay registros para mostrar.',
  vacioHijos: 'Todavía no hay registros.',
  mostrando: 'Mostrando {mostrados} de {total}',
  verMas: 'Ver más resultados',
  seleccioneConjunto: 'Elige un conjunto en la barra superior para ver esta información.',
  sinConjuntos: 'Todavía no hay conjuntos. Crea el primero en Propiedades → Conjuntos.',
  conjunto: 'Conjunto',
  si: 'Sí',
  no: 'No',
  seleccione: 'Selecciona',
  campoRequerido: 'Este campo es obligatorio.',
  campoInvalido: 'El valor no es válido.',
  campoRango: 'Debe estar entre {minimo} y {maximo}.',
  campoLongitud: 'Máximo {maximo} caracteres.',
  archivoSubiendo: 'Subiendo el archivo',
  archivoElegir: 'Elegir archivo',
  archivoVer: 'Ver archivo',
  fichaDatos: 'Datos',
  fichaRegistro: 'Registro',
  creado: 'Creado',
  actualizado: 'Actualizado',
  identificador: 'Identificador',
  resultado: 'Resultado',
  sinDatos: 'Sin datos.',
  confirmarEliminar: '¿Eliminar "{nombre}"? Esta acción no se puede deshacer.',
  confirmarAccion: '¿Confirmas "{accion}" sobre "{nombre}"?',
  toasts: {
    creado: 'Registro creado',
    actualizado: 'Registro actualizado',
    eliminado: 'Registro eliminado',
    accion: 'Acción realizada',
    tituloCarga: 'No pudimos cargar la información',
    tituloGuardar: 'No pudimos guardar',
    tituloAccion: 'No pudimos completar la acción',
  },
  errores: {
    carga: 'Inténtalo de nuevo en breve.',
    guardar: 'Revisa los datos e inténtalo de nuevo.',
    conflicto: 'Ya existe un registro igual o fue modificado por otra persona. Actualiza la lista e inténtalo de nuevo.',
    eliminar: 'No se pudo eliminar: puede estar en uso por otros registros.',
    accion: 'No se pudo realizar la acción. Inténtalo de nuevo.',
  },
};

export type TextosCrud = typeof TEXTOS_CRUD_ES;

export const TEXTOS_CRUD: DiccionarioIdiomas<TextosCrud> = {
  es: TEXTOS_CRUD_ES,
  en: {
    inicio: 'Home',
    buscar: 'Search',
    todos: 'All',
    nuevo: 'New',
    editar: 'Edit',
    eliminar: 'Delete',
    verFicha: 'View details',
    historial: 'History',
    guardar: 'Save',
    cancelar: 'Cancel',
    cerrar: 'Close',
    confirmar: 'Confirm',
    agregar: 'Add',
    consultar: 'Search',
    vacio: 'There are no records to show.',
    vacioHijos: 'There are no records yet.',
    mostrando: 'Showing {mostrados} of {total}',
    verMas: 'Show more results',
    seleccioneConjunto: 'Choose a complex in the top bar to see this information.',
    sinConjuntos: 'There are no complexes yet. Create the first one in Properties → Complexes.',
    conjunto: 'Complex',
    si: 'Yes',
    no: 'No',
    seleccione: 'Select',
    campoRequerido: 'This field is required.',
    campoInvalido: 'The value is not valid.',
    campoRango: 'It must be between {minimo} and {maximo}.',
    campoLongitud: 'At most {maximo} characters.',
    archivoSubiendo: 'Uploading the file',
    archivoElegir: 'Choose file',
    archivoVer: 'View file',
    fichaDatos: 'Details',
    fichaRegistro: 'Record',
    creado: 'Created',
    actualizado: 'Updated',
    identificador: 'Identifier',
    resultado: 'Result',
    sinDatos: 'No data.',
    confirmarEliminar: 'Delete "{nombre}"? This action cannot be undone.',
    confirmarAccion: 'Confirm "{accion}" on "{nombre}"?',
    toasts: {
      creado: 'Record created',
      actualizado: 'Record updated',
      eliminado: 'Record deleted',
      accion: 'Action completed',
      tituloCarga: "We couldn't load the information",
      tituloGuardar: "We couldn't save",
      tituloAccion: "We couldn't complete the action",
    },
    errores: {
      carga: 'Please try again shortly.',
      guardar: 'Check the data and try again.',
      conflicto: 'A matching record already exists or it was changed by someone else. Refresh the list and try again.',
      eliminar: "It couldn't be deleted: it may be in use by other records.",
      accion: "The action couldn't be completed. Please try again.",
    },
  },
};
